export default {
	title: "निगरानी",
	url: "watch",
	subtitle: "अनामीकृत शोध द्वारा निर्मित रणनीतिक निगरानी रिपोर्ट: सार्वजनिक स्रोतों से पूछताछ से पहले परियोजना के विषय को तटस्थ किया जाता है। रिपोर्ट में मैक्रो संदर्भ (PESTEL), क्षेत्रीय संदर्भ (पोर्टर की 5 शक्तियाँ) और आंतरिक संदर्भ शामिल हैं, मजबूत और कमजोर संकेतों के साथ।",
	current: "वर्तमान रिपोर्ट",
	archive: "संग्रह",
	context_tab: "संदर्भ",
	empty: "इस परियोजना के लिए अभी कोई निगरानी रिपोर्ट नहीं है।",
	generated_on: "जारी की गई",
	actions: {
		generate: "रिपोर्ट बनाएँ",
		generate_new: "नई रिपोर्ट बनाएँ",
		generating: "बनाई जा रही है… (लगभग दस मिनट)",
		retry: "पुनः प्रयास करें",
		print: "प्रिंट करें",
		delete: "यह रिपोर्ट हटाएँ",
		delete_confirm: "इस रिपोर्ट को स्थायी रूप से हटाएँ?"
	},
	steps: {
		anonymizing: "विषय का अनामीकरण",
		researching: "शोध और लेखन",
		done: "रिपोर्ट उपलब्ध",
		elapsed: "{{minutes}} मिनट से"
	},
	messages: {
		failed: "निर्माण विफल रहा",
		neutral_subject: "भेजा गया अनामीकृत विषय",
		confirm_title: "अनामीकृत निगरानी शुरू करें?",
		confirm_body: "सार्वजनिक स्रोतों पर किसी भी शोध से पहले परियोजना के विषय को अनामीकृत किया जाएगा। रिपोर्ट बनने में लगभग दस मिनट लगते हैं।"
	}
};
